var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddJob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.68863 13.0004H5.80316C3.53895 13.0004 2.40716 13.0004 1.70358 12.2836C1 11.5667 1 10.4128 1 8.10567C1 5.79852 1 4.64462 1.70358 3.92778C2.40716 3.21094 3.53895 3.21094 5.80316 3.21094H8.20505C10.4693 3.21094 11.6017 3.21094 12.3053 3.92778C12.8465 4.47915 12.9709 5.28946 13 6.68462",
    stroke: "#5B6B79",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.84241 3.21053L9.77926 3.01474C9.46662 2.04211 9.31062 1.55579 8.93862 1.27789C8.56599 1 8.0721 1 7.08241 1H6.91631C5.92789 1 5.43336 1 5.06136 1.27789C4.68873 1.55579 4.53273 2.04211 4.2201 3.01474L4.1582 3.21053",
    stroke: "#5B6B79",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.6317 10.4755H8.5791M11.1054 7.94922V13.0019",
    stroke: "#5B6B79",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddJob);
export default __webpack_public_path__ + "static/media/add_job.8ecb0ed9972ad6d558f82ded68ad2e54.svg";
export { ForwardRef as ReactComponent };